<template>
  <button class="btn btn-danger" @click.prevent="handleShowModal">
    <slot />
  </button>
</template>

<script>
import ManualReturnModal from '@/components/ManualReturn/ManualReturnModal'

export default {
  name: 'ManualReturn',
  props: {
    device: {
      type: Object,
      required: true
    },
    loan: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleShowModal() {
      return this.$modal.show(ManualReturnModal, {
        device: this.device,
        loan: this.loan
      },
      { width: '85%', height: 'auto', scrollable: true })
    }
  }
}
</script>
